import { Card } from 'antd'

import { useLocales } from 'src/locales'

import { PersonDemographicsFields } from './PersonDemographicsFields'

/** Civil and migration data on the person profile; saved with the person as one `demographics` object. */
export const PersonDemographicsCard = () => {
  const { t } = useLocales()

  return (
    <Card title={t('demographics.title')}>
      <PersonDemographicsFields namePrefix={['demographics']} />
    </Card>
  )
}
